import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { LoanRequestsDuplicatesTableDefinitionZod, LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetDuplicates = z.array(
    LoanRequestsTableDefinitionZod.merge(
        z.object({
            duplicateMatch: LoanRequestsDuplicatesTableDefinitionZod.or(z.record(z.never())),
        }),
    ),
);

export type SchemaLoanRequestResolver_GetDuplicates = z.infer<typeof schemaLoanRequestResolver_GetDuplicates>;

export type LoanRequestResolver_GetDuplicates = Resolver<Arguments, SchemaLoanRequestResolver_GetDuplicates>;
